export default __webpack_public_path__ + "static/media/logo.add1d5da.jpg";